import styled from 'styled-components';

import { paragraph } from '../../../theme/typography';
import { media } from '../../../theme/media';
import { TextWithLinks } from '../../../shared/components/textWithLinks';

export const List = styled.ul`
  padding: 0 0 0 18px;
  display: grid;
  grid-template-columns: 1fr;
  ${media.tablet`
    grid-template-columns: 1fr ${props => (props.oneItem ? '' : '1fr')};
  `};
  grid-column-gap: 60px;
  row-gap: 16px;
  list-style-position: outside;
  list-style-type: disc;
`;

export const RowText = styled(TextWithLinks)`
  ${paragraph}
`;

export const Text = styled(TextWithLinks)``;

export const RowItem = styled.li`
  ${paragraph}
`;
